import CompanyOverview from '../components/routes/companies/CompanyOverview.vue'
import CompanyInfo from '../components/routes/companies/CompanyInfo.vue'
import CompanySalary from '../components/routes/companies/CompanySalary.vue'
import CompanyLog from '../components/routes/companies/CompanyLog.vue'
import CompanyDeleteTimesheets from '../components/routes/companies/CompanyDeleteTimesheets.vue'

const companyRoutes = [
  {
    name: 'company',
    path: '/company',
    component: CompanyOverview,
    redirect: {
      name: 'company.info'
    },
    children: [
      {
        name: 'company.info',
        props: true,
        path: 'info',
        component: CompanyInfo
      },
      {
        name: 'company.salary',
        props: true,
        path: 'salary',
        component: CompanySalary
      },
      {
        name: 'company.log',
        props: true,
        path: 'log',
        component: CompanyLog
      },
      {
        name: 'company.deleteTimesheets',
        path: 'remove-timesheets',
        component: CompanyDeleteTimesheets
      }
    ]
  }
]

export default companyRoutes
